import React from "react";
import { deleteFamily } from "../services/familyService"; // Import delete function
import "../styles/list.css";
import { FamilyResponse } from "../types/FamilyTypes";
import { useNavigate } from "react-router-dom";

interface FamilyTableProps {
  families: FamilyResponse[];
  loadFamilies: () => void;
}

const FamilyTable: React.FC<FamilyTableProps> = ({ families, loadFamilies }) => {
  const navigate = useNavigate();

  // Function to handle delete
  const handleDelete = async (id: number) => {
    if (window.confirm("Are you sure you want to delete this family?")) {
      await deleteFamily(id);
      loadFamilies(); // Refresh message list
    }
  };

  const convertUtcToLocal = (utcDateString: string) => {
    return new Date(utcDateString + "z").toLocaleString();
  };

  return (
    <div className="overflow-x-auto message-table">
      <table>
        <thead>
          <tr>
            <th>Family Name</th>
            <th>Members</th>
            <th>Created Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {families.map((fam) => (
            <tr key={fam.id} className="hover:bg-gray-100">
              <td>{fam.familyName}</td>
              <td className="schedules">
                {fam.members.length > 0 ? (
                  <div className="pl-4 members">
                    {fam.members.sort((a, b) => {
                        return (b.isPatient ? 1 : 0) - (a.isPatient ? 1 : 0);
                      }).map((member) => (
                        <div key={member.id}>
                          {member.isPatient ? <p>Patient</p> : <p>Caretaker</p>}
                          {member.isPatient ? <p>Name: {member.firstName} {member.lastName}</p> : null}
                          <p>Phone Number: {member.phoneNumber}</p>
                          {/* <p>Birth Date: {member.birthDate}</p> */}
                        </div>
                    ))}
                  </div>
                ) : (
                  "No Registered members"
                )}
              </td>
              <td>{convertUtcToLocal(fam.createdDate)}</td>
              <td>
              <div className="button-group">
                  <button
                    className="update-btn"
                    onClick={() => navigate(`/family/${fam.id}`)}
                  >
                    Detail
                  </button>
                  <button
                    className="delete-btn"
                    onClick={() => handleDelete(fam.id)}
                  >
                    Delete
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FamilyTable;
